<template>
   <g>
      <path
         d="M4.51685 5.01772C5.04968 5.01772 5.56069 4.80608 5.93745 4.42934C6.31422 4.05261 6.52589 3.54165 6.52589 3.00886C6.52589 2.47608 6.31422 1.96512 5.93745 1.58838C5.56069 1.21165 5.04968 1 4.51685 1C3.98402 1 3.47301 1.21165 3.09625 1.58838C2.71948 1.96512 2.50781 2.47608 2.50781 3.00886C2.50781 3.54165 2.71948 4.05261 3.09625 4.42934C3.47301 4.80608 3.98402 5.01772 4.51685 5.01772Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M6.21044 11.0658L5.83676 14.055H3.20793L2.70567 10.0372H1V8.5306C1.00013 7.65368 1.32803 6.80846 1.91935 6.16084C2.51066 5.51322 3.32268 5.10996 4.19605 5.0302C5.06942 4.95045 5.94107 5.19995 6.63992 5.72976C7.33877 6.25956 7.81437 7.0314 7.97337 7.89379M9.68607 9.62342V8.97054C9.68607 8.70415 9.7919 8.44867 9.98029 8.2603C10.1687 8.07194 10.4242 7.96611 10.6906 7.96611H11.1045C11.3709 7.96611 11.6264 8.07194 11.8148 8.2603C12.0031 8.44867 12.109 8.70415 12.109 8.97054V9.62342M7.79657 10.5093C7.79657 10.0202 8.19336 9.62342 8.68256 9.62342H13.1145C13.6037 9.62342 14.0005 10.0202 14.0005 10.5103V13.1691C14.0007 13.2855 13.978 13.4008 13.9336 13.5084C13.8891 13.616 13.8239 13.7138 13.7416 13.7961C13.6592 13.8784 13.5615 13.9437 13.4539 13.9881C13.3462 14.0325 13.2309 14.0552 13.1145 14.055H8.68256C8.56613 14.0552 8.4508 14.0325 8.34319 13.9881C8.23558 13.9437 8.1378 13.8784 8.05548 13.7961C7.97316 13.7138 7.90791 13.616 7.86347 13.5084C7.81904 13.4008 7.79631 13.2855 7.79657 13.1691V10.5093Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-contractor',
         viewBox: '0 0 15 15',
         width: 15,
         height: 15,
         fill: 'none',
      };
   },
};
</script>
